import React from "react";
export const FaqBubble: React.FC<any> = () => (
	<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
		<g
			id="m_0.0_Home_Screen_fullPG_aftHRs-(1)"
			transform="translate(-321.000000, -127.000000)"
			fill="#374B5A"
		>
			<g id="Group" transform="translate(0.000000, 100.000000)">
				<g id="1B3_m" transform="translate(314.547852, 18.019608)">
					<g id="Icon_FAQ_sollid" transform="translate(6.500000, 9.031250)">
						<path
							d="M27.6666667,0 C28.9553311,-2.36723813e-16 30,1.04466892 30,2.33333333 L30,21.6666667 C30,22.9553311 28.9553311,24 27.6666667,24 L14,24 L5,30 L5,24 L2.33333333,24 C1.04466892,24 1.04599429e-15,22.9553311 0,21.6666667 L0,2.33333333 C-6.01905085e-16,1.04466892 1.04466892,-6.51454607e-16 2.33333333,0 L27.6666667,0 Z M15.4100794,16.8352216 C14.7889592,16.8352216 14.2854417,17.3198237 14.2854417,17.9176108 C14.2854417,18.5153978 14.7889592,19 15.4100794,19 C16.0311996,19 16.534717,18.5153978 16.534717,17.9176108 C16.534717,17.3198237 16.0311996,16.8352216 15.4100794,16.8352216 Z M12.321295,7.13305682 C11.4490515,7.93334406 10.9695582,9.05158788 11.0014998,10.2109996 L13.3407461,10.2109996 C13.3079152,9.62775075 13.5343295,9.05858033 13.9634749,8.64555635 C14.3926203,8.23253237 14.9840069,8.01462357 15.5900214,8.04622116 C16.0867801,8.00032809 16.5805187,8.15889345 16.9491004,8.48269269 C17.3176821,8.80649193 17.5266816,9.26528235 17.5243982,9.74557223 C17.5243982,10.8279614 16.8383692,11.2284455 16.0511228,11.7696401 C14.7703097,12.4025775 14.0212202,13.7243174 14.1617316,15.1033988 L16.4110069,15.1033988 C16.4110069,13.8586512 16.9395866,13.685469 18.3003981,12.6896709 C19.3867482,12.0476636 20.0342424,10.8962431 19.998601,9.66980498 C19.998601,7.60244159 18.35663,6.01132944 15.578775,6.01132944 C14.3770098,5.92523611 13.1935385,6.33276958 12.321295,7.13305682 Z"
							id="Combined-Shape"
						></path>
					</g>
				</g>
			</g>
		</g>
	</g>
);

export const FaqBubbleHighlight: React.FC<any> = () => (
	<>
		<defs>
			<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="faq-bubble">
				<stop stopColor="#FADC00" offset="0%"></stop>
				<stop stopColor="#FADC00" offset="26.5148968%"></stop>
				<stop stopColor="#FFCE00" offset="53.9842308%"></stop>
				<stop stopColor="#FFB900" offset="81.7904472%"></stop>
				<stop stopColor="#FFA800" offset="100%"></stop>
			</linearGradient>
		</defs>
		<g stroke="none " strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(-1662.000000, -461.000000)">
				<g transform="translate(1662.000000, 461.000000)">
					<path
						d="M2.33333333,22 C1.04466892,22 -7.30362544e-16,20.9553311 0,19.6666667 L0,2.33333333 C2.86273335e-16,1.04466892 1.04466892,1.12490223e-15 2.33333333,0 L25.6666667,0 C26.9553311,-2.08176245e-15 28,1.04466892 28,2.33333333 L28,19.6666667 C28,20.9553311 26.9553311,22 25.6666667,22 L12.6,22 L4.2,28 L4.2,22 L2.33333333,22 Z"
						fill="url(#faq-bubble)"
					></path>
					<path
						d="M14.3124077,14.3905835 C14.8493512,14.3905835 15.2846299,14.8254828 15.2846299,15.3619584 C15.2846299,15.898434 14.8493512,16.3333333 14.3124077,16.3333333 C13.7754642,16.3333333 13.3401854,15.898434 13.3401854,15.3619584 C13.3401854,14.8254828 13.7754642,14.3905835 14.3124077,14.3905835 Z M14.2359545,4.6670253 L14.458241,4.67683412 C16.8596299,4.67683412 18.2790743,6.10475527 18.2790743,7.9600814 C18.3098855,9.06073096 17.7501423,10.0940571 16.8110188,10.6702175 C15.6346299,11.5638824 15.1776854,11.7193024 15.1776854,12.8363836 L15.1776854,12.8363836 L13.233241,12.8363836 C13.1117722,11.5987464 13.7593422,10.4125695 14.8665743,9.84454877 C15.5471299,9.3588613 16.1401854,8.99945258 16.1401854,8.02807764 C16.1421594,7.59704826 15.9614844,7.18531327 15.6428544,6.89472421 C15.3242243,6.60413515 14.8973991,6.4618329 14.4679632,6.50301899 C13.9440782,6.47466218 13.4328387,6.67022135 13.0618528,7.0408839 C12.690867,7.41154645 12.4951372,7.92234041 12.5235188,8.44576886 L12.5235188,8.44576886 L10.5012966,8.44576886 C10.4736838,7.40527117 10.8881942,6.40171903 11.6422278,5.68351253 C12.3962613,4.96530603 13.4193438,4.59957087 14.458241,4.67683412 Z"
						fill="#FFFFFF"
						fillRule="nonzero"
					></path>
				</g>
			</g>
		</g>
	</>
);

export const FaqBubbleHighlightOutline: React.FC<any> = () => (
	<>
		<defs>
			<linearGradient
				x1="50%"
				y1="0%"
				x2="50%"
				y2="100%"
				id="faq-bubble-outline-1"
			>
				<stop stopColor="#FADC00" offset="0%"></stop>
				<stop stopColor="#FADC00" offset="26.5148997%"></stop>
				<stop stopColor="#FFCE00" offset="53.984201%"></stop>
				<stop stopColor="#FFB900" offset="81.7903996%"></stop>
				<stop stopColor="#FFA800" offset="100%"></stop>
			</linearGradient>
			<linearGradient
				x1="50%"
				y1="0%"
				x2="50%"
				y2="100%"
				id="faq-bubble-outline-2"
			>
				<stop stopColor="#FADC00" offset="0%"></stop>
				<stop stopColor="#FADC00" offset="26.5148997%"></stop>
				<stop stopColor="#FFCE00" offset="53.984201%"></stop>
				<stop stopColor="#FFB900" offset="81.7903996%"></stop>
				<stop stopColor="#FFA800" offset="100%"></stop>
			</linearGradient>
		</defs>
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(-931.000000, -1115.000000)" fillRule="nonzero">
				<g transform="translate(0.000000, 975.000000)">
					<g transform="translate(927.000000, 134.020062)">
						<g transform="translate(0.000000, 5.979938)">
							<g transform="translate(4.000000, 0.000000)">
								<path
									d="M29,31.8 C29.6,31.8 30.1,32 30.7,32.4 C31.1,32.8 31.3,33.4 31.3,34 C31.3,34.7 31,35.2 30.6,35.6 C29.7,36.4 28.3,36.4 27.4,35.6 C26.9,35.3 26.7,34.7 26.7,34 C26.7,33.4 27,32.8 27.4,32.4 C27.8,32 28.3,31.8 29,31.8 Z M29.4,9.5 C31.1,9.5 32.6,9.8 33.9,10.4 C35.1,11 36.1,11.9 36.8,12.9 C37.5,14 37.8,15.1 37.8,16.3 C37.8,17.3 37.6,18.1 37.2,18.8 C36.8,19.5 36.3,20.2 35.8,20.7 C35.2,21.3 34.2,22.3 32.7,23.6 C32.3,23.9 32,24.3 31.7,24.6 C31.4,24.9 31.2,25.2 31.1,25.5 C31,25.8 30.9,26 30.8,26.3 C30.7,26.5 30.6,27 30.5,27.6 C30.3,28.6 29.8,29.1 28.8,29.1 C28.3,29.1 27.8,28.9 27.5,28.6 C27.2,28.3 27,27.8 27,27.1 C27,26.2 27.1,25.4 27.5,24.6 C27.8,23.9 28.2,23.3 28.7,22.8 C29.2,22.2 29.9,21.6 30.8,20.8 C31.6,20.1 32.1,19.6 32.5,19.2 C32.9,18.8 33.2,18.4 33.5,17.9 C33.8,17.4 33.9,16.9 33.9,16.3 C33.9,15.2 33.4,14.3 32.6,13.5 C31.7,12.8 30.7,12.4 29.4,12.4 C28,12.4 26.8,12.8 26.1,13.6 C25.4,14.3 24.9,15.4 24.4,16.8 C23.9,18.3 23.1,18.5 22.5,18.5 C21.9,18.5 21.5,18.3 21.1,17.9 C20.7,17.5 20.5,17.1 20.5,16.7 C20.5,15.6 20.8,14.5 21.5,13.4 C22.2,12.3 23.3,11.3 24.6,10.6 C26,9.9 27.6,9.5 29.4,9.5 Z"
									fill="url(#faq-bubble-outline-1)"
								></path>
								<path
									d="M40.6751326,56 C40.0539444,56 39.4406767,55.779726 38.9506029,55.3580319 L28.6033322,46.4221862 L7.40282939,46.4221862 C3.32060821,46.4221862 0,43.0765099 0,38.9635456 L0,7.45864064 C0,3.34561415 3.32060821,0 7.40282939,0 L48.597186,0 C52.6793995,0 56,3.34561415 56,7.45864064 L56,38.9635456 C56,43.0765099 52.6793995,46.4221862 48.597186,46.4221862 L43.3242112,46.4221862 L43.3242112,53.3309507 C43.3242112,54.3745145 42.7215506,55.320635 41.7824575,55.7570763 C41.4274817,55.9197929 41.0499794,56 40.6751326,56 Z M9.18413474,2.80881187 C4.59099509,2.80881187 2.99658203,5.25488281 2.99658203,9 C2.99658203,9 2.99658203,37.9993896 2.99658203,37.9993896 C2.99658203,41.0300293 4.51702048,43.6133744 9.18413474,43.6133744 C9.18413474,43.6133744 15.7913763,43.6133744 29.0058594,43.6133744 C29.6376702,43.6133744 30.3525492,43.840182 30.8320312,44.2552181 L40.380722,52.6853027 L40.380722,46.2823614 C40.380722,44.8077077 41.5661876,43.6133744 43.0297852,43.6133744 C45.5509954,43.6129675 46.8116005,43.612764 46.8116005,43.612764 C51.4136513,43.612764 53.03125,41.4451904 53.03125,37.9993896 C53.03125,37.9993896 53.03125,8.99938965 53.03125,8.99938965 C53.03125,4.64099121 51.1026161,2.80820151 46.8116005,2.80820151 C46.8116005,2.80820151 9.18413474,2.80881187 9.18413474,2.80881187 Z"
									fill="url(#faq-bubble-outline-2)"
								></path>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</>
);
